// extracted by mini-css-extract-plugin
export default {"icon":"icon-icon-MPZ_cL","loop":"icon-loop-FZOkg0","spin":"icon-spin-ks5PZl"};